import hoistNonReactStatics from 'hoist-non-react-statics';
export function withStatics(component, statics) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hoistNonReactStatics(component, statics);
}
